import { Currency } from "@daytrip/legacy-enums";

export function transformCurrencyToCurrencyISO(currency: Currency): string {
    switch (currency) {
        case Currency.Euro:
            return "EUR";
        case Currency.Dollar:
            return "USD";
        case Currency.CanadianDollar:
            return "CAD";
        case Currency.AustralianDollar:
            return "AUD";
        case Currency.BritishPound:
            return "GBP";
        case Currency.NewZealandDollar:
            return "NZD";
        case Currency.CzechKoruna:
            return "CZK";
        case Currency.MexicanPeso:
            return "MXN";
        default:
            return "";
    }
}
